import { useEffect, useRef, useState } from "react";
import { post } from "src/utils/networkUtils";

const IDLE_WARNING_MS = 25 * 60 * 1000; // 25 min
const IDLE_LOGOUT_MS = 30 * 60 * 1000; // 30 min

export default function useSessionTimeout() {
  const [showWarning, setShowWarning] = useState(false);
  const warningTimer = useRef(null);
  const logoutTimer = useRef(null);

  const logout = () => {
    const adminToken = localStorage.getItem("adminToken");
    if (adminToken) {
      post("/admin-auth/logout", {}).catch(() => {});
    }
    localStorage.removeItem("adminToken");
    localStorage.removeItem("user");
    window.location.href = "/";
  };

  const resetTimers = () => {
    setShowWarning(false);
    clearTimeout(warningTimer.current);
    clearTimeout(logoutTimer.current);
    warningTimer.current = setTimeout(
      () => setShowWarning(true),
      IDLE_WARNING_MS
    );
    logoutTimer.current = setTimeout(logout, IDLE_LOGOUT_MS);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((e) => window.addEventListener(e, resetTimers));
    resetTimers();

    // Re-check session validity when tab regains focus
    const onFocus = () => {
      const adminToken = localStorage.getItem("adminToken");
      if (!adminToken) {
        logout();
        return;
      }
    };
    window.addEventListener("focus", onFocus);

    return () => {
      events.forEach((e) => window.removeEventListener(e, resetTimers));
      window.removeEventListener("focus", onFocus);
      clearTimeout(warningTimer.current);
      clearTimeout(logoutTimer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { showWarning, extendSession: resetTimers, logout };
}
